import React, { useReducer } from "react";
// import axios from "axios";
import ProductContext from "./ProductContext";
import ProductReducer from "./ProductReducer";
import {
  // GET_PRODUCTS,
  SET_ALL_PRODUCTS,
  SET_PRODUCTS,
  // SET_LOADING,
} from "../../types";

const ProductState = (props) => {
  const initialState = {
    all_products: null,
    products: null,
    // products_loading: false,
  };

  const [state, dispatch] = useReducer(ProductReducer, initialState);

  const setAllProducts = (data) => {
    dispatch({
      type: SET_ALL_PRODUCTS,
      payload: data,
    });
  };

  const setProducts = (data) => {
    dispatch({
      type: SET_PRODUCTS,
      payload: data,
    });
  };

  return (
    <ProductContext.Provider
      value={{
        all_products: state.all_products,
        products: state.products,
        // products_loading: state.products_loading,
        // getProducts,
        setAllProducts,
        setProducts,
      }}
    >
      {props.children}{" "}
    </ProductContext.Provider>
  );
};

export default ProductState;
